import { Field, Formik } from "formik";
import React, { useState, Fragment } from "react";
import Input from "../components/Pages/Payment/Input";
import { ContactSheme } from "../validations/ContactSheme";
import { SendContact, SendReview } from "./api";
import { toast } from "react-toastify";
import PhoneInputW from "./Reservation/PhoneInput";
import { useTranslation } from "../context/TranslationContext";

const ContactModal = ({ result, id }) => {
  const { nameSurname, email, phone, sendBtnText } = useTranslation();
  const HandleSubmit = (values, actions) => {
    SendContact(values)
      .then((e) => {
        if (e.data.error) {
          toast.error(e.data.error);
        } else {
          toast.success(e.data.success);
        }
      })
      .finally(() => {
        actions.setSubmitting(false);
      });
  };
  return (
    <Formik
      initialValues={{
        name: "",
        islm_id: id,
        email: "",
        telefon: "",
        telefonIsValid: false,
      }}
      validationSchema={ContactSheme}
      onSubmit={HandleSubmit}
    >
      {(props) => (
        <form className="flex flex-wrap w-full" onSubmit={props.handleSubmit}>
          <div className="relative z-0 w-full group p-1 mt-4">
            <Input name="name" placeholder=" " label={nameSurname} />
          </div>
          <div className="relative z-0 w-full group p-1 mt-4">
            <Input name="email" placeholder=" " label={email} />
          </div>
          <div className="relative z-0 w-full mt-4 group min-h-[70px] p-1">
            <PhoneInputW
              name="telefon"
              validname="telefonIsValid"
              label={phone}
              mode={"simple"}
              isrequired="required"
            ></PhoneInputW>
          </div>
          <hr className="h-0.25 bg-gray-400 w-full mt-8 mb-4" />
          <button
            type="submit"
            disabled={props.isSubmitting || !props.isValid || !props.dirty}
            className="mt-4 text-white mx-auto px-4 py-3 duration-200 bg-[#00BBC0] hover:bg-[#00bac0bb] focus:ring-4 focus:outline-none focus:ring-blue-300  font-medium rounded-lg text-sm  text-center disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {sendBtnText}
          </button>
        </form>
      )}
    </Formik>
  );
};

export default ContactModal;
